<div class="menu">
  @if (config.searchable && config.type !== tipos.TREE) {
    <app-busqueda-option (valueChange)="filtrado($event)"/>
    <mat-divider/>
  }
  @switch (config.type) {
    @case (tipos.TREE) {
      <app-tree-menu
      [options]="arregloMostrar"
      [searchable]="config.searchable"
      (selected)="selection($event)"
      />
    }
    @case (tipos.COMMON) {
      @for (elemnt of arregloMostrar; track $index) {
        <app-options-select
          (selected)="selection($event)"
          [element]="elemnt">
        </app-options-select>
      }
    }
    @case (tipos.CONSOLIDADO) {
      <app-options-select
          (selected)="selection($event)"
          [element]="consolidado">
      </app-options-select>
      <mat-divider/>
      @if (!consolidado.selected) {
        @for (elemnt of arregloMostrar; track $index) {
          <app-options-select
            (selected)="selection($event)"
            [element]="elemnt">
          </app-options-select>
        }
      }
    }
  }
</div>